import React from 'react';
import useToggleAction from '@/hooks/useToggleAction';
import { db } from '@root/firebase';

// Colors used below:
// Idle circle: #EFEFEF
// Hover/Active circle: #FFF7E0 (very light gold)
// Idle icon: #555555 (dark grey)
// Hover/Active icon: #FFC107 (bright gold)

function FavoriteButton({
  collectionPath,
  documentId,
  userId,
  className = '',
}) {
  const { state: isFavorited, toggleAction } = useToggleAction(
    db,
    collectionPath,
    documentId,
    'favorite',
    userId
  );

  return (
    <>
      <div
        className='tooltip-container'
        style={{ display: 'inline-block', marginRight: '10px' }}
      >
        <button
          type='button'
          className={[
            'reaction-btn',
            'reaction-fav',
            isFavorited ? 'is-active' : '',
            className,
          ].join(' ')}
          title={isFavorited ? 'Unfavorite' : 'Favorite'}
          onClick={toggleAction}
        >
          {/* Star icon */}
          <svg
            className='reaction-icon'
            width='18'
            height='18'
            viewBox='0 0 24 24'
            aria-hidden='true'
          >
            <path d='M12 2l2.92 5.91 6.53.95-4.72 4.6 1.11 6.48L12 17.77l-5.84 3.07 1.11-6.48L2.55 8.86l6.53-.95L12 2z' />
          </svg>
        </button>
        <span className='tooltip'>
          {isFavorited ? 'Unfavorite' : 'Favorite'}
        </span>
      </div>
    </>
  );
}

export default FavoriteButton;
